<section *transloco="let t" class="relative py-12 sm:py-24">
  <!-- Decorative Ring -->
  <div
    aria-hidden="true"
    class="pointer-events-none absolute inset-y-0 left-1/2 -z-10 w-screen -translate-x-1/2 overflow-x-clip"
  >
    <img
      src="/assets/images/home/decor/half-ring-2.webp"
      alt=""
      class="absolute -right-14 top-24 w-[11rem] opacity-70 sm:-right-16 sm:top-28 sm:w-[19rem] lg:-right-12 lg:w-[22rem]"
    />
  </div>

  <!-- Title & Subtitle -->
  <div class="mx-auto max-w-4xl text-center">
    <h2 class="text-3xl font-extrabold leading-tight tracking-tight text-slate-900 sm:text-5xl">
      {{ t('home.mostLoved.title') }}
    </h2>
    <p class="mt-4 text-base text-slate-600 sm:text-xl">
      {{ t('home.mostLoved.subtitle') }}
    </p>
  </div>

  <!-- Programme cards -->
  <div class="mt-10 grid auto-rows-fr gap-5 sm:mt-14 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4">
    @if (loading()) {
      @for (skeleton of skeletons; track skeleton) {
        <div class="aspect-[4/5] animate-pulse rounded-2xl bg-slate-100"></div>
      }
    } @else {
      @for (programme of programmes(); track programme.title) {
        <app-programme-card [programme]="programme" />
      }
    }
  </div>

  <!-- CTA -->
  <div class="mt-10 flex justify-center sm:mt-12">
    <a appButton size="lg" routerLink="/programmes">
      {{ t('home.mostLoved.cta') }}
    </a>
  </div>
</section>
